export interface Logo {
    img: string
    title: string
    size?: 'small' | 'big'
    href?: string
}

export const NDD_LOGOS: Logo[] = [
    {
        img: 'presovsky-kraj.png',
        title: 'Prešovské dobrovoľnícke centrum',
        href: 'https://www.dobrovolnictvopo.sk/'
    },
    {
        img: 'growni-gray.png',
        title: 'GROWNi',
        href: 'https://growni.sk/'
    },
    {
        img: 'cdbb.png',
        title: 'Centrum dobrovoľníctva, n.o., (BB kraj)',
        href: 'http://www.centrumdobrovolnictva.sk/'
    },
    {
        img: 'pdco-gray.png',
        title: 'Platforma dobrovoľníckych centier a organizácií',
        href: 'https://dobrovolnictvo.sk/'
    },
    {
        img: 'zilinsky-kraj.png',
        title: 'V.I.A.C. - INŠTITÚT PRE PODPORU A ROZVOJ MLÁDEŽE (ZA kraj)',
        href: 'https://www.dobrovolnictvoza.sk/'
    },
    {
        img: 'trenciansky-kraj.png',
        title: 'Trenčianske dobrovoľnícke centrum, o.z.',
        href: 'https://www.dobrovolnictvotn.sk/'
    },
    {
        img: 'trnavsky-kraj.png',
        title: 'Dobrovoľnícke centrum Trnavského kraja',
        href: 'https://dobrovolnickecentrumtt.sk/'
    },
    {
        img: 'nitriansky-kraj.png',
        title: 'Komunitné centrum (NR kraj)',
        href: 'http://www.ncdnitra.sk/'
    }
]

export const DOBROWEEK_ORGS: Logo[] = [
    {
        img: 'logo_BDC.png',
        title: 'BDC',
        href: 'https://www.bdcentrum.sk/'
    },
    {
        img: 'cdbb.png',
        title: 'Centrum dobrovoľníctva, n.o., (BB kraj)',
        href: 'http://www.centrumdobrovolnictva.sk/'
    },
    {
        img: 'nitriansky-kraj.png',
        title: 'Komunitné centrum (NR kraj)',
        href: 'http://www.ncdnitra.sk/'
    },
    {
        img: 'presovsky-kraj.png',
        title: 'Prešovské dobrovoľnícke centrum',
        size: 'big',
        href: 'https://www.dobrovolnictvopo.sk/'
    },
    {
        img: 'trnavsky-kraj.png',
        title: 'Dobrovoľnícke centrum Trnavského kraja',
        size: 'big',
        href: 'https://dobrovolnickecentrumtt.sk/'
    },
    {
        img: 'trenciansky-kraj.png',
        title: 'Trenčianske dobrovoľnícke centrum, o.z.',
        href: 'https://www.dobrovolnictvotn.sk/'
    },
    {
        img: 'zilinsky-kraj.png',
        title: 'V.I.A.C. - INŠTITÚT PRE PODPORU A ROZVOJ MLÁDEŽE (ZA kraj)',
        size: 'big',
        href: 'https://www.dobrovolnictvoza.sk/'
    },
    {
        img: 'pdco-gray.png',
        title: 'Platforma dobrovoľníckych centier a organizácií',
        href: 'https://dobrovolnictvo.sk/'
    },
    // {
    //     img: 'growni-gray.png',
    //     title: 'GROWNi',
    //     href: 'https://growni.sk/'
    // }
]

export const DOBROWEEK_LOGOS: Logo[] = [
    {
        img: 'logo_min_skolstva_nove.png',
        title: 'Ministerstvo školstva, výskumu, vývoja a mládeže Slovenskej republiky'
    },
    {
        img: 'logo-nivam.png',
        title: 'NIVAM'
    },
    {
        img: 'nadacia_slsp_logo.png',
        title: 'Nadácia Slovenskej sporiteľne'
    },
    {
        img: 'growni-gray.png',
        title: 'GROWNi'
    },
    {
        img: 'logo-hejdude.png',
        title: 'hejDude',
        size: 'big'
    },
    {
        img: 'logo-sme.png',
        title: 'SME'
    },
    {
        img: 'logo-fun-radio.png',
        title: 'Fun rádio',
        size: 'big'
    },
    {
        img: 'KL_Nadacny_fond_Logo_CMYK.png',
        title: 'Nadačný fond Kaufland'
    },
    {
        img: 'ncpf_logo_primary.png',
        title: 'Centrum pre filantropiu',
        size: 'big'
    }
]
